import Head from 'next/head';
import { usePartner } from './Partner';

export interface PartnerProviderProps {
	children: React.ReactNode;
}

export const HelmetProvider = ({
	children,
}: {
	children?: React.ReactNode;
}) => {
	const { name, favico } = usePartner();

	return (
		<>
			<Head>
				<title>{name?.standard}</title>
				<link rel="shortcut icon" href={favico} />
			</Head>
		</>
	);
};
